import { createHttpLink as baseCreateHttpLink } from '@apollo/client';
import type { SiteCode, Locale } from '@olxpwa-lib/i18n/types';
import { useLocalisationContext } from '@olxpwa-lib/i18n/client';
import { useHostProps } from '~features/host-props';
import type { ApiEnv } from '~types';
import { getEndpointPerMarket } from '~config';

type CreateHttpLinkOptions = {
  siteCode: SiteCode;
  apiEnv: ApiEnv;
  locale: Locale;
};

export const createHttpLink = ({ apiEnv, siteCode, locale }: CreateHttpLinkOptions) => {
  const endpoint = getEndpointPerMarket(apiEnv, siteCode);

  return baseCreateHttpLink({
    uri: `${endpoint}/graphql`,
    headers: {
      'olx-locale': locale,
    },
    credentials: 'same-origin',
  });
};

export const useHttpLink = () => {
  const { apiEnv, siteCode } = useHostProps();
  const {
    selectedLanguage: { locale },
  } = useLocalisationContext();

  return createHttpLink({ locale, apiEnv, siteCode });
};
